var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data)?_c('li',{staticClass:"usa-sidenav__item",class:{ 'usa-current': _vm.isCurrent }},[_c('a',{ref:"sideMenuLink",attrs:{"href":_vm.data.fields.menuItemTargetLink,"aria-current":_vm.isCurrent ? 'page' : 'false'}},[_vm._v(" "+_vm._s(_vm.data.fields.menuItemText)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }